import React, { useState, useMemo, useEffect } from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";

import {
    Card,
    CardBody,
    Container,
    Label,
} from "reactstrap";

import CommonTable from "components/Common/TableContainer";
import { submitDrugCsvUploadReportFilterData } from "model/DrugCsvUploadReportModel";
import dayjs from "dayjs";

const DrugCsvUploadReport = () => {
    const [reportData, setReportData] = useState([]);

    const columns = [
        { Header: "Client", accessor: "client" },
        { Header: "User 1", accessor: "user1" },
        { Header: "Time 1", accessor: "time1" },
        { Header: "User 2", accessor: "user2" },
        { Header: "Time 2", accessor: "time2" },
    ];

    const formatDateTime = (value) => {
        if (!value) return "";
        const parsed = dayjs(value);
        return parsed.isValid() ? parsed.format("MM-DD-YYYY hh:mm A") : value;
    };

    const filteredData = useMemo(() => reportData, [reportData]);

    const unwrapReportRows = (payload) => {
        if (Array.isArray(payload)) return payload;
        const root = payload?.data ?? payload;
        if (Array.isArray(root)) return root;
        const nested = root?.records ?? root?.rows ?? root?.items;
        return Array.isArray(nested) ? nested : [];
    };

    const getDrugCsvUploadList = async () => {
        const response = await submitDrugCsvUploadReportFilterData({});
        const rows = unwrapReportRows(response?.data ?? response);
        /**
         * Filter API shape: clientId, clientName, loginTime1Iso, loginTime2Iso,
         * userId1, userId2, userName1, userName2 (plus legacy keys if any).
         */
        const mappedData = rows.map((row, index) => ({
            ...row,
            client:
                row?.clientName ?? "-",
            user1:
                row?.userName1 ?? "-",
            user2:
                row?.userName2 ??
                "-",
            time1: formatDateTime(
                row?.loginTime1Iso ??
                    "-"
            ),
            time2: formatDateTime(
                row?.loginTime2Iso ??
                    "-"
            ),
            id:
                row?.id ??
                ([
                    row?.clientId,
                    row?.userId1,
                    row?.userId2,
                    row?.loginTime1Iso,
                    row?.loginTime2Iso,
                    index,
                ]
                    .map((part) =>
                        part === undefined || part === null ? "" : String(part)
                    )
                    .join(":") ||
                    String(index)),
        }));
        setReportData(mappedData);
    };

    useEffect(() => {
        getDrugCsvUploadList();
    }, []);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Card>
                        <CardBody>
                        <Label className="fs-5"><strong>Drug CSV Upload Report</strong></Label>
                        <hr />
                            <CommonTable columns={columns} data={filteredData} isActionRequired={false} />
                        </CardBody>
                    </Card>


                </Container>
            </div>
        </React.Fragment>
    );
};

DrugCsvUploadReport.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func,
};

export default withRouter(DrugCsvUploadReport);
